import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerTable from "./BannerTable";
import { getBanners, uploadBannerImage, addBanner, deleteBanner } from "../../redux/actions/bannerAction";
import { customConfirmPopup } from "../../utils/commonFunctions";

const Banner = () => {
    const dispatch = useDispatch();
    const allBanners = useSelector((state) => state.banner.allBanners);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getBanners(setLoading));
    }, [dispatch]);

    const banners = (allBanners || []).map((item) => ({
        ...item,
        time: new Date(item.time),
    }));

    const onUpload = async (file) => dispatch(uploadBannerImage(file));

    const onAdd = (path, next) => dispatch(addBanner(path, next, setLoading));

    const onDelete = (id) => {
        customConfirmPopup(() => dispatch(deleteBanner(id)), "Do you want to delete this banner?");
    };

    return (
        <BannerTable
            heading="Home Screen Carousel Banners"
            allBanners={banners}
            loading={loading}
            onUpload={onUpload}
            onAdd={onAdd}
            onDelete={onDelete}
        />
    );
};

export default Banner;
